import React, { Component } from "react";
import Hero from './../../components/hero';
import { Link } from "react-router-dom";
import  './../../utils/analytics';
import  {Colors} from './../../utils/variables';
import ScrollFadeIn from './../../components/scrollFadeIn';
import Testimonials from './testimonials';
import FAQ from './../../components/faq';
import SkillsClinicsSection from './../../components/skillsClinicsSection';
import skillsClinicsData from './../../data/skillsClinics.json';

export default class extends Component {
  componentDidMount = ()=>{
    window.scrollTo(0, 0)
  }
  render() {
    return (
		<div className="light-grey-background" style={{backgroundColor:Colors.primaryDark}}>
      <div className="slant-bottom">
        <Hero
          title={'Free to Roam'}
          poweredByImage="/images/powered-by-ibis.png"
          //subtitle={'Where You Look is Where You Go'}
          backgroundImage={'/images/event-hero.jpg'}
          height={'full'} /*full, half,threequarter*/
          tint={''}
        />
      </div>
      <div>
        <div className="gutter">
          <div className="medium-max-width-container lip shadow" style={{color:Colors.white, backgroundColor:Colors.primary}}>
            <div className="centered-text" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
            <div className="large-padding" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <h1 className="oversized-text">{'Dirt, sweat, and adventure'}</h1>
              {/* <h2>{'August 14th-16th, 2027'}</h2> */}
              <h2>{'Summer 2027'}</h2>
            </div>
              <img src="/images/event-banner.jpg" alt="Event Kicker" className="full-width" />
              <div className="medium-padding">
                <p>{'This is what a weekend away on your bike, with like minded people is all about.  This weekend getaway will be an exhilarating blend of adventure and community on and off the trails with all of us doing hard things together and then celebrating our achievements over trail talks, happy hour, and cool raffles.  Participants can look forward to group rides, ranging from challenging uphills to thrilling downhill descents, ensuring a memorable experience for everyone.  Alongside the biking adventures, the weekend features a welcome party Friday evening, wellness workshops, bike skills clinics, a trail building workshop on Kirkwood trails, bike demos, delicious meals and an endless amount of time to connect with fellow riders. This is sure to be an amazing weekend that you won’t want to miss.'}</p>
                <h5 className="subheading" style={{fontWeight:'normal'}}>{`Please note:  At this time, this event is not intended for brand new/unskilled mtb riders due to technical trails and our small team’s limited resources to properly and safely support new mtb riders, but we welcome beginners looking to take the next step in their mountain biking journey and all intermediate and advanced riders. 

If you're unsure whether the event is the right fit for your current skill level, feel free to reach out, and we'd be happy to help you assess whether this is the right event for you. `}</h5>
              </div>
            </div>
          </div>
          <div className="medium-max-width-container" style={{marginTop:'10vh', color:Colors.white}}>
            <h2 className="centered-text">{'Peak Pursuits Weekend schedule'}</h2>
          </div>
          <div className="medium-max-width-container shadow"  style={{marginTop:'5vh', marginBottom:'5vh', color:Colors.white, backgroundColor:Colors.primary}}>
            <ScrollFadeIn>
              <div className="row alternating-grid-row" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
                <div className="small-12 medium-6">
                  <img className="alternating-grid-image" alt="" src="images/square.png" style={{'backgroundImage':'url(images/welcome.jpg)'}} />
                </div>
                <div className="small-12 medium-6 row">
                  <div className="alternating-grid-text center-position">
                    <h2>{"FRIDAY"}</h2>
                    <p><b>{'Chill Kickoff and Settle In'}</b></p>
                    <p><span className="subheading">{'Set up camp/check-in to Kirkwood Lodging'}</span></p>
                    <p><span className="subheading">{'Receive swag bag and weekend info packet'}</span></p>
                    <p><span className="subheading">{'Ease into the weekend with a relaxed happy hour—good vibes, good community, and the perfect start to what\'s ahead.'}</span></p>
                  </div>
                </div>
              </div>
            </ScrollFadeIn>
            <ScrollFadeIn>
              <div className="row alternating-grid-row reverse" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
                <div className="small-12 medium-6"  style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage:'url(images/event-kicker.jpg)'}}>
                  <img className="alternating-grid-image" alt="" src="images/square.png"  />
                </div>
                <div className="small-12 medium-6 row">
                  <div className="alternating-grid-text center-position" style={{color:Colors.white}}>
                    <h2>{"SATURDAY"}</h2>
                    <p><b>{'Ride, Learn, Connect'}</b></p>
                    <p><span className="subheading">{'Wake up with morning yoga'}</span></p>
                    <p><span className="subheading">{'Fuel up with breakfast'}</span></p>
                    <p><span className="subheading">{'Spend the day diving into group rides, sharpening your skills with A Singletrack Mind clinics and testing out Ibis Bike demos.'}</span></p>
                    <p><span className="subheading">{'Refuel with lunch'}</span></p>
                    <p><span className="subheading">{'Get inspired by our keynote speaker'}</span></p>
                    <p><span className="subheading">{'Wrap it all up with a community dinner to share stories from the trail.'}</span></p>
                  </div>
                </div>
              </div>
            </ScrollFadeIn>
            <ScrollFadeIn>
              <div className="row alternating-grid-row" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
                <div className="small-12 medium-6">
                  <img className="alternating-grid-image" alt="" src="images/square.png" style={{'backgroundImage':'url(images/trail-build.jpg)'}} />
                </div>
                <div className="small-12 medium-6 row">
                  <div className="alternating-grid-text center-position" style={{color:Colors.white}}>
                    <h2>{"SUNDAY"}</h2>
                    <p><b>{'One Last Lap'}</b></p>
                    <p><span className="subheading">{'Start the day with breakfast and yoga'}</span></p>
                    <p><span className="subheading">{'More group rides'}</span></p>
                    <p><span className="subheading">{'Trail building party—giving back to the trails that brought us all together.'}</span></p>
                  </div>
                </div>
              </div>
            </ScrollFadeIn>
          </div>
        </div>
        <ScrollFadeIn>
          <div className="gutter shadow event-skills-clinics--hide-datetime" style={{ color: Colors.white, backgroundColor: Colors.primary, backgroundImage:'url(/images/topo-texture.png)' }}>
            <SkillsClinicsSection data={skillsClinicsData} variant="cards" showSectionHeader={true} showRegisterButton={false} cardBackgroundColor={Colors.primaryDark} />
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="large-padding" style={{color:Colors.white, backgroundColor:Colors.primary}}>
            <FAQ />
          </div>
        </ScrollFadeIn>
        <div>
          <ScrollFadeIn>
            <div className="shadow" style={{color:Colors.white, backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="large-padding centered-text">
                <h1>{'Testimonials'}</h1>
                <div className="testimonial-row row" style={{alignItems: 'stretch'}}>
                  {Testimonials && Testimonials.map((testimonial) =>{
                    return(
                      <div className="small-12 medium-4">
                        <div className="small-padding" style={{height:'100%'}}>
                          <div className="testimonial-card medium-padding" style={{height:'100%'}}>
                            <p className="subheading">{testimonial.quote}</p>
                            <p><b>{testimonial.author}</b></p>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </ScrollFadeIn>
        </div>
        <div className="slant-top large-padding centered-text" style={{color:Colors.white}}>
          <ScrollFadeIn>
            <h1>{'Safety'}</h1>
            <div className="small-max-width-container">
              <p className="subheading">{'Peak Pursuits Mountain Biking will prioritize your safety throughout our weekend together. Minimizing the risk of injuries and accidents will be of the utmost importance to Peak Pursuits Mountain Biking.  A few key points to remember:  always wear appropriate safety gear, perform pre-ride checks, know your limits, practice trail etiquette, and stay hydrated and fueled. With these precautions in place, we will hit the trails with confidence and peace of mind, ready to embrace the adventure that awaits. '}</p>
              <div className="small-padding" style={{paddingBottom:0}}>
                <h2 className="fancy-font">{'Happy riding!'}</h2>
              </div>
            </div>
          </ScrollFadeIn>
        </div>
        <div>
          <ScrollFadeIn>
            <div className="shadow" style={{color:Colors.white, backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="large-padding centered-text">
                <h1>{'Lets Do This Thing'}</h1>
                <p className="cursive-text subheading">{'Space is limited to 75 people, register today to save your spot'}</p>
                {/* Temporary: restore Register Today link when registration reopens
                <Link to="/register">
                  <div className="card-button button" style={{color:Colors.white, backgroundColor:Colors.tertiary}}>
                    {'Register Today'}
                  </div>
                </Link>
                */}
                <p className="white" style={{ fontSize: '1.25rem', fontWeight: 600 }}>{'Coming Soon'}</p>
              </div>
            </div>
          </ScrollFadeIn>
        </div>
      </div>
    </div>
    );
  }
}
